import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Typography,
  Divider,
  Box,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  People as PeopleIcon,
  Send as SendIcon,
  LocalHospital as HospitalIcon,
  ChevronLeft as ChevronLeftIcon,
  Menu as MenuIcon
} from '@mui/icons-material';

const Sidebar = ({ activeView, onViewChange, open, onClose, isCollapsed, onToggleCollapse, isSplitScreen = false }) => {
  const menuItems = [
    {
      id: 'patients',
      label: 'Patient Information',
      icon: <PeopleIcon />,
      description: 'View pending patient cases'
    },
    {
      id: 'sendapp',
      label: 'Send App to Patient',
      icon: <SendIcon />,
      description: 'Send StrepApp download link'
    }
  ];

  const drawerWidth = 280;
  const miniDrawerWidth = 64;

  const sidebarContent = (
    <Box sx={{ width: isCollapsed ? miniDrawerWidth : drawerWidth }} role="presentation">
      <Box className="p-4 bg-blue-600 text-white">
        <Box className="flex items-center justify-between mb-2">
          <Box className="flex items-center">
            <HospitalIcon className={isCollapsed ? "" : "mr-2"} />
            {!isCollapsed && (
              <Typography variant="h6" component="div">
                StrepApp Portal
              </Typography>
            )}
          </Box>
          <IconButton
            onClick={onToggleCollapse}
            size="small"
            sx={{ color: 'white' }}
          >
            {isCollapsed ? <MenuIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </Box>
        {!isCollapsed && (
          <Typography variant="body2" className="opacity-90">
            Physician Dashboard
          </Typography>
        )}
      </Box>
      
      <Divider />
      
      <List className="pt-4">
        {menuItems.map((item) => (
          <ListItem key={item.id} disablePadding className="mb-2">
            {isCollapsed ? (
              <Tooltip title={item.label} placement="right">
                <ListItemButton
                  onClick={() => {
                    onViewChange(item.id);
                    if (onClose) onClose();
                  }}
                  className={`mx-2 rounded-lg justify-center ${
                    activeView === item.id
                      ? 'bg-blue-100 text-blue-700'
                      : 'hover:bg-gray-100'
                  }`}
                >
                  <ListItemIcon
                    className={`min-w-0 ${
                      activeView === item.id ? 'text-blue-700' : 'text-gray-600'
                    }`}
                  >
                    {item.icon}
                  </ListItemIcon>
                </ListItemButton>
              </Tooltip>
            ) : (
              <ListItemButton
                onClick={() => {
                  onViewChange(item.id);
                  if (onClose) onClose();
                }}
                className={`mx-2 rounded-lg ${
                  activeView === item.id
                    ? 'bg-blue-100 text-blue-700'
                    : 'hover:bg-gray-100'
                }`}
              >
                <ListItemIcon
                  className={
                    activeView === item.id ? 'text-blue-700' : 'text-gray-600'
                  }
                >
                  {item.icon}
                </ListItemIcon>
                <Box>
                  <ListItemText
                    primary={item.label}
                    secondary={item.description}
                    primaryTypographyProps={{
                      fontWeight: activeView === item.id ? 'bold' : 'normal'
                    }}
                  />
                </Box>
              </ListItemButton>
            )}
          </ListItem>
        ))}
      </List>
    </Box>
  );

  // For split-screen mode, render content directly without Drawer
  if (isSplitScreen) {
    return (
      <div className="h-full">
        {sidebarContent}
      </div>
    );
  }

  // For mobile/drawer mode, use Material-UI Drawer
  return (
    <Drawer
      variant="temporary"
      open={open}
      onClose={onClose}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        display: { xs: 'block', md: 'none' },
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: drawerWidth,
        },
      }}
    >
      {sidebarContent}
    </Drawer>
  );
};

export default Sidebar;
